module.exports = __webpack_public_path__ + "static/media/ic-economic.fd2c7c0a.webp";